import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["index", "onDelete"];
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Icon } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ModalHeaderRight');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "verticalDivider"
});
function ModalHeaderRight(_ref) {
  let {
      index,
      onDelete
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const handleDelete = useCallback(() => {
    onDelete(index);
  }, [index, onDelete]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "trash",
    onClick: handleDelete,
    className: classes.icon
  }), _ref2);
}
process.env.NODE_ENV !== "production" ? ModalHeaderRight.propTypes = {
  index: PropTypes.number,
  onDelete: PropTypes.func
} : void 0;
export default /*#__PURE__*/memo(ModalHeaderRight);